import { render, staticRenderFns } from "./SalesDetails.vue?vue&type=template&id=d008f6dc&scoped=true"
import script from "./SalesDetails.vue?vue&type=script&lang=js"
export * from "./SalesDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesDetails.vue?vue&type=style&index=0&id=d008f6dc&prod&scoped=true&lang=css"
import style1 from "./SalesDetails.vue?vue&type=style&index=1&id=d008f6dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d008f6dc",
  null
  
)

export default component.exports